const sharedMobileDesktop = require('../pages/content/portalOverview_'+language+'.js');

export default {
  large: [

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        blockModifiers: ['center'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['alignTop'],
                component1: {
                  type: 'header-full',
                  data: {
                    blockModifiers: ['noPadding', 'mediumWeight', 'smallerFontSize'],
                    text: 'Spotin Portal. To manage all your business needs.',
                    textMobile: 'Spotin Portal. To manage all your business needs.',
                    subText: 'A tool for analytics, campaign <br>features and building &<br>discovering partnerships.'
                  }
                },
                img3: {
                  blockModifiers: ['max400pxHeight'],
                  // src: 'spotin_portal.svg',
                  src: 'spotin_portal.png',
                  alt: 'Spotin Portal'
                }
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['centerBottom'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 2,
                header1: 'Discover, Optimize, and Thrive Together',
                text2: "<p>Welcome to the hub of content commerce success – Spotin Portal. Designed exclusively for sellers and content makers using Spotin network, Spotin Portal is your gateway to finding new partnerships, managing existing collaborations, setting up campaigns, analysing the performance and supercharging your content commerce.</p>",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        // blockModifiers: ['noMobilePaddingTop'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['alignCenter', 'mobileReverseColumn','noColumnMargin'],
                columns: 3,
                component1: {
                  type: 'animation',
                  data: {
                    loop: true,
                    autoplay: true,
                    src: "portal_dashboard.json",
                    caption: "Performance metrics in a single dashboard view"
                  }
                },
                header3: 'Dashboard for Performance & Analytics',
                text3: "<p>Monitor your KPI metrics, sales and earnings. Gain insights into your content commerce performance alongside your partners to identify trends and patterns.</p><p>Understand what’s working and where there’s room for improvement to fine-tune your strategies and maximize your earnings potential.</p>",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['alignCenter','noColumnMargin'],
                // columns: 3,
                header1: 'Campaign Management',
                text1: "<p>With Spotin Portal, sellers setup exclusive special offers tailored for the audiences of hand-picked publishers. Infused with a sense of urgency through limited-time availability, these campaigns serve as compelling incentives that drive higher conversion rates, sales, and ultimately, your earnings.</p>",
                component3: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['450px'],
                    loop: true,
                    autoplay: true,
                    src: "Exclusive_offer.json",
                    caption: "Build site specific campaigns with special pricing and product offers"
                  }
                },
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['alignCenter', 'endMargin', 'mobileReverseColumn','noColumnMargin'],
                // columns: 3,
                component1: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['450px'],
                    loop: true,
                    autoplay: true,
                    src: "Partnership_handshake.json",
                    caption: "Discover new sellers/publishers and enhance your current relationships"
                  }
                },
                header3: 'Build Partnerships',
                text3: "<p>Expand your horizons with Spotin Portal’s intuitive partner discovery feature. Here sellers and publishers can connect to align forces and and unlock new avenues for growth. Collaborate and keep track of ongoing partnerships seamlessly, all in one place.</p>",
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        blockModifiers: ['centerBottom'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 2,
                header1: 'Overview of Portal Features',
                text2: "<p>Your tool for content commerce success – Spotin Portal. Designed exclusively for the needs of sellers and content makers. Spotin Portal is your gateway to onboarding yourself with Spotin, finding new partnerships, managing products and orders, making exclusive campaigns with your content commerce partners, and groundbreaking analytics of what drives sales focusing with a holistic view from discovery to purchase.</p>",
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        sections: [
          {
            full: {
              component: 'columned-expandablelist',
              data: {
                active: null,
                expandableGroups: sharedMobileDesktop.list
              },
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: 'Related'
              }
            },
            bottom: {
              component: 'Related',
              data: {
                buttons: [
                  {
                    icon: 'arrowUpRight',
                    label: 'Spotin for Sellers',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'sellers',
                  },
                  {
                    icon: 'arrowUpRight',
                    label: 'Spotin for Publishers',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'publishers',
                  }
                ],
              }
            }
          }
        ]
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./pages/Portal.js